import * as XLSX from "xlsx-js-style";

const DARK_BLUE = "1F4E79";
const WHITE = "FFFFFF";

/**
 * Downloads a one-sheet .xlsx: `columns` is [{ label, value: (row, index) => cell }, …] in column order, `rows` the records.
 * Numbers stay numbers (so Excel can sum them); the header row is bold on dark blue, like the enrollee exports.
 */
export function downloadSheet(rows, columns, fileName, sheetName = "Sheet1") {
  const body = rows.map((row, i) => columns.map((col) => {
    const v = col.value(row, i);
    return v === null || v === undefined ? "" : v;
  }));
  const worksheet = XLSX.utils.aoa_to_sheet([columns.map((c) => c.label), ...body]);

  columns.forEach((col, c) => {
    const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c })];
    if (cell) {
      cell.s = {
        font: { bold: true, color: { rgb: WHITE }, sz: 11 },
        fill: { patternType: "solid", fgColor: { rgb: DARK_BLUE } },
        alignment: { horizontal: "center", wrapText: true },
      };
    }
  });
  // width from the longest value in each column (capped), so the sheet is readable without resizing
  worksheet["!cols"] = columns.map((col, c) => ({
    wch: Math.min(60, body.reduce((w, r) => Math.max(w, String(r[c]).length), Math.max(8, String(col.label).length)) + 2),
  }));
  worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, String(sheetName).replace(/[[\]\\/?*:]/g, "-").slice(0, 31));
  XLSX.writeFile(workbook, fileName);
}

/** "Drug formulary 2026-10-27.xlsx" */
export function datedFileName(base) {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${base} ${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}.xlsx`;
}
